import { z } from 'zod';
import { shared } from '@tig-dpqa-cloud/contract-backend-common';

export const AthenaCredentials = shared.AWSCredentials.extend({
  workgroup: z.string().min(1).describe('Athena work group name for querying the events.'),
  database: z.string().min(1).describe('Metadata table name (in glue) for the events table.'),
  outputLocation: z.string().min(1).describe('S3 uri where athena results are stored. This should be used as-is with the athena SDK client.'),
});

export type AthenaCredentials = z.infer<typeof AthenaCredentials>;
